<template>
  <el-dialog
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :visible.sync="show"
    class="rv-dialog rv-dialog_center"
    lock-scroll
    width="80%"
  >
    <div class="main_content">
      <div class="map_search">
        <div class="label">关键字搜索</div>
        <el-input
          v-model="input"
          placeholder="请输入内容"
          id="tipinput"
        ></el-input>
      </div>
      <div class="gaode_Map" :id="mapId"></div>
    </div>
    <div class="form_box">
      <el-form
        ref="elForm"
        :model="dataForm"
        size="small"
        label-width="100px"
        label-position="right"
        :disabled="!!isDetail"
      >
        <el-form-item label="我的详细地址" prop="kqLocation">
          <el-input
            v-model="dataForm.kqLocation"
            placeholder="自动带出"
            clearable
            :style="{ width: '100%' }"
            disabled
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dataFormSubmit" v-if="!isDetail"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
  <script>
/* eslint-disable */
import AMapLoader from "@amap/amap-jsapi-loader"; //引入AMapLoader
export default {
  components: {},
  props: {
    mapId: String,
    value: Boolean,
    onDialogClose: Function,
    addressInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      isDetail: false,
      dataForm: {
        kqLocation: undefined,
        kqLongitude: undefined,
        kqLatitude: undefined,
        address: "",
      },
      input: "",
      map: null,
      auto: null,
      placeSearch: null,
      lnglat: [],
      markers: [],
      position: {},
      show: false,
    };
  },
  watch: {
    value(v) {
      this.show = v;
      if (v) {
        this.$nextTick(() => {
          this.initMap();
        });
      }
    },
  },
  beforeUnmount() {
    this.map.destroy();
    this.map = null;
  },
  methods: {
    dialogClose() {
      this.$emit("onDialogClose", false);
    },
    // 地图初始化
    initMap() {
      let centerLen = [116.397428, 39.90923];
      const { initValue = {} } = this.addressInfo;
      if (initValue && initValue.longitude && initValue.latitude) {
        centerLen = [initValue.longitude, initValue.latitude];
        this.dataForm.kqLocation = initValue[this.addressInfo.prop];
      } else if (this.dataForm.kqLongitude && this.dataForm.kqLatitude) {
        const { kqLongitude, kqLatitude } = this.dataForm;
        centerLen = [kqLongitude, kqLatitude];
      }
      window._AMapSecurityConfig = {
        securityJsCode: "06e39b2ca4ca22b1faa554ec216d9862"
      }
      AMapLoader.load({
        key: "1e63157f153a26a844dfe1b0ec3ff2a0", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Geocoder",
          "AMap.Geolocation",
        ],
      })
        .then((AMap) => {
          this.map = new AMap.Map(`${this.$props.mapId}`, {
            // 设置地图容器id
            viewMode: "3D", //  是否为3D地图模式
            zoom: 15, // 初始化地图级别
            center: centerLen, //中心点坐标
            resizeEnable: true,
          });

          this.setMarker(centerLen);
          // 关键字查询
          this.searchMap();
          // // 获取当前定位
          // this.getLocation();
          // 监听鼠标点击事件
          this.map.on("click", this.clickMapHandler);
        })
        .catch((e) => {});
    },
    // 关键字查询
    searchMap() {
      // 搜索框自动完成类
      this.auto = new AMap.AutoComplete({
        input: "tipinput", // 使用联想输入的input的id
      });
      //构造地点查询类
      this.placeSearch = new AMap.PlaceSearch({
        map: this.map,
      });
      // 当选中某条搜索记录时触发
      this.auto.on("select", this.selectSite);
    },
    //选中查询出的记录
    selectSite(e) {
      console.log('selectSite===', e)
      if (e.poi.location) {
        this.lnglat = [e.poi.location.lng, e.poi.location.lat];
        this.placeSearch.setCity(e.poi.adcode);
        this.placeSearch.search(e.poi.name); //关键字查询
        let geocoder = new AMap.Geocoder({});
        let that = this;
        geocoder.getAddress(this.lnglat, function (status, result) {
          if (status === "complete" && result.regeocode) {
            that.dataForm.kqLocation = result.regeocode.formattedAddress;
            that.dataForm.kqLongitude = e.poi.location.lng;
            that.dataForm.kqLatitude = e.poi.location.lat;
            const { province, city, district, township } =
              result.regeocode.addressComponent;
            that.dataForm.address = `${province}-${city}-${district}-${township}`;
          } else {
          }
        });
      } else {
        this.$message.error("查询地址失败，请重新输入地址");
      }
    },
    // 点击地图事件获取经纬度，并添加标记
    clickMapHandler(e) {
      this.lnglat = [e.lnglat.getLng(), e.lnglat.getLat()];
      this.setMarker(this.lnglat);
      // 点击地图上的位置，根据经纬度转换成详细地址
      let geocoder = new AMap.Geocoder({});
      let that = this;
      geocoder.getAddress(this.lnglat, function (status, result) {
        if (status === "complete" && result.regeocode) {
          that.dataForm.kqLongitude = e.lnglat.getLng();
          that.dataForm.kqLatitude = e.lnglat.getLat();
          that.dataForm.kqLocation = result.regeocode.formattedAddress;
          const { province, city, district, township } =
            result.regeocode.addressComponent;
          that.dataForm.address = `${province}-${city}-${district}-${township}`;
        } else {
        }
      });
      this.position = {
        longitude: e.lnglat.getLng(),
        latitude: e.lnglat.getLat(),
        address: that.address,
      };
      this.input = that.address; //把查询到的地址赋值到输入框
    },
    //  添加标记
    setMarker(lnglat) {
      this.removeMarker();
      let marker = new AMap.Marker({
        position: lnglat,
      });
      marker.setMap(this.map);
      this.markers.push(marker);
    },
    // 删除之前后的标记点
    removeMarker() {
      if (this.markers) {
        this.map.remove(this.markers);
      }
    },
    // 获取当前定位
    getLocation() {
      const context = this;
      let geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过10秒后停止定位，默认：5s
        position: "RB", //定位按钮的停靠位置
        offset: [10, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
        zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
      });
      context.map.addControl(geolocation);
      geolocation.getCurrentPosition(function (status, result) {
        if (status == "complete") {
          context.onlocationComplete(result);
        } else {
          context.onlocationError(result);
        }
      });
    },
    onlocationComplete(data) {
      console.log("success", data);
    },
    //解析定位错误信息
    onlocationError(data) {
      console.log("error", data);
    },
    dataFormSubmit() {
      this.$emit("mapSelection", this.dataForm);
    },
  },
};
</script>
  
<style lang="scss" scoped>
.main_content {
  margin-bottom: 30px;

  .map_search {
    margin-bottom: 5px;
    display: flex;
    align-items: center;

    .label {
      width: 120px;
      font-weight: bold;
    }
  }
}

#panel {
  position: absolute;
  top: 50px;
  right: 20px;
}

.gaode_Map {
  overflow: hidden;
  width: 100%;
  height: 400px;
  margin: 0;
}

:deep(.el-dialog .el-dialog__header) {
    display: none;
}
</style>
  